import axios from 'axios';

// Response interceptor - 401 hatalarını yakala
axios.interceptors.response.use(
  (response) => {
    // Başarılı response'ları olduğu gibi döndür
    return response;
  },
  (error) => {
    // 401 hatası geldiğinde
    if (error.response && error.response.status === 401) {
      // LocalStorage'dan token'ı sil
      localStorage.removeItem('userToken');

      // Login sayfasına yönlendir (sadece login sayfasında değilsek)
      if (window.location.pathname !== '/') {
        window.location.href = '/';
      }
    }

    // Hatayı tekrar fırlat ki catch bloğu yakalayabilsin
    return Promise.reject(error);
  }
);

export default axios;
